export default {
  pages: {
    key: "title",
    data: [
      {title: 'Consultas',   url: '/queries',      icon: 'UserMinusIcon', is_bookmarked: false},
      {title: 'Asignación cobranza',   url: '/cobranza',      icon: 'PackageIcon', is_bookmarked: false},
      {title: 'Gestión',   url: '/cobranza2',      icon: 'BoxIcon', is_bookmarked: false},
    ]
  }
}
